import CustomerDetailModal from "./CustomerDetailModal";

export default CustomerDetailModal